module.exports = __webpack_public_path__ + "img/banner.13ddbb13.png";